export let ValidateError = /*#__PURE__*/function (ValidateError) {
  ValidateError["REQUIRED"] = "required";
  ValidateError["MAX_LENGTH"] = "maxLength";
  return ValidateError;
}({});